import axios from 'axios';

//menu-service.js
export default class MenuService {
    getFooterMenu(type, params) {
        return axios.get(`/api/menu/footer?language=${language}`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/menu-service.js